import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  candidateId: null,
}

export const candidateSlice = createSlice({
  name: 'candidate',
  initialState,
  reducers: {
    setCandidateId: (state, action) => {
      state.candidateId = action.payload || initialState.candidateId
    },
  },
})

export const { setCandidateId } = candidateSlice.actions

export default candidateSlice.reducer
